import { Linkedin } from "lucide-react";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/Reveal";
import { team, heroImages } from "@/data/content";

const TeamCard = ({ member, index }) => (
  <Reveal delay={index * 0.13}>
    <article
      data-testid={`team-card-${member.slug}`}
      className="group h-full overflow-hidden rounded-[2rem] border border-navy/10 bg-white transition-all duration-500 hover:-translate-y-2.5 hover:border-gold/50 hover:shadow-2xl hover:shadow-navy/15"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-gradient-to-br from-navy via-navy-light to-navy-deep">
        <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #E9B44C 1px, transparent 0)", backgroundSize: "26px 26px" }} />
        <div className="absolute inset-0 flex items-center justify-center transition-transform duration-700 group-hover:scale-110">
          <span className="font-display text-8xl italic text-gold/90">{member.initials}</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-navy-deep/90 to-transparent" />
        <a
          href="https://www.linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`linkedin-link-${member.slug}`}
          aria-label={`Profilo LinkedIn di ${member.name}`}
          onClick={(e) => e.stopPropagation()}
          className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition-all duration-300 hover:border-gold hover:bg-gold hover:text-navy"
        >
          <Linkedin size={18} />
        </a>
        <span className="absolute bottom-5 left-6 text-[10px] font-semibold uppercase tracking-[0.3em] text-white/50">
          Vobis Credit S.r.l.
        </span>
      </div>
      <div className="p-8">
        <h3 className="font-display text-2xl text-navy">{member.name}</h3>
        <p className="mt-2 text-xs font-semibold uppercase tracking-[0.18em] leading-relaxed text-gold-dark">{member.role}</p>
        <p className="mt-4 text-sm leading-relaxed text-navy/60">{member.bio}</p>
      </div>
    </article>
  </Reveal>
);

const Management = () => (
  <div data-testid="management-page">
    <PageHero
      eyebrow="Il Team"
      lines={["Il nostro", <span key="i" className="italic text-gold">Management</span>]}
      description="Una guida esperta e complementare: competenze finanziarie, legali e commerciali al servizio di ogni operazione."
      image={heroImages.management}
    />

    <section className="bg-cream py-28" data-testid="team-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-base leading-relaxed text-navy/65 md:text-lg">
            Il valore di Vobis Credit nasce dalle persone. Un management con esperienza consolidata
            nel mercato dei crediti deteriorati, che coordina personalmente ogni fase: dalla selezione
            e acquisizione dei portafogli, allo sviluppo commerciale, fino alla pianificazione
            economico-finanziaria.
          </p>
        </Reveal>
        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {team.map((m, i) => (
            <TeamCard key={m.slug} member={m} index={i} />
          ))}
        </div>
      </div>
    </section>

    <CtaBand title="Vuoi parlare con il nostro team?" text="Ogni operazione inizia da una conversazione: contattaci per un primo confronto riservato." />
  </div>
);

export default Management;
